import {FaviconService} from "./service/FaviconService";

export default angular.module("tfApp.favicon", [])
                      .service(FaviconService.id, FaviconService)
                      .name;
